@if (patientFile) {
    <div class="modal-component small">
        <div class="modal-header-content">
            <div class="header-text-container">
                <div class="header-text">
                    <span>Berechtigungen für </span>
                    @if (shownName) {
                        <span class="text-app-secondary-10">{{ shownName }}</span>
                    } @else {
                        <span class="text-app-secondary-10">{{ patientFile.fileName }}</span>
                    }
                </div>
            </div>
            <button class="modal-close-button" type="button" (click)="onClose()">
                <i class="fa-solid fa-times icon-center"></i>
            </button>
        </div>
        <div class="modal-body-container">
            <div class="text-xl font-medium text-app-primary-20">Wählen Sie die Ärzte, welche das Dokument einsehen dürfen</div>
            <div class="space-y-2">
                @for (doctor of doctorList; track doctor.id) {
                    <mat-checkbox [checked]="doctor.checked" (change)="updateDoctorList($event.checked, doctor)" class="block">
                        <span class="text-sm text-app-primary-10">{{ doctor.title ? doctor.title + ' ' : ''}}{{ doctor.firstName }} {{ doctor.lastName }}</span>
                    </mat-checkbox>
                }
            </div>
        </div>
        <div class="modal-button-container">
            <button type="button" class="btn quaternary-button" (click)="onClose()">Abbrechen</button>
            <button type="button" class="btn primary-button" (click)="onSubmit()">Speichern</button>
        </div>
    </div>
}
